import { html, LitElement, PropertyValues, TemplateResult } from 'lit';
import Handlebars from 'handlebars';
import { customElement, property, state } from 'lit/decorators.js';
import morphdom from 'morphdom';

@customElement('cv-template')
export class TemplateComponent extends LitElement {

  @property({ type: Object })
  data: Record<string, unknown> = {};

  private innerDOM: HTMLElement = document.createElement('div');

  @state()
  private _templateCache: HandlebarsTemplateDelegate | null = null;

  /* LitElement uses a shadow root by default. We want to render the template */
  createRenderRoot() {
    return this;
  }

  updated(changedProperties: PropertyValues) {
    super.updated(changedProperties);
    if (changedProperties.has('data')) {
      this.requestUpdate();
    }
  }

  generateUniqueKey() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 5; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  assignUniqueIds(subtree: HTMLElement, prefix: String) {
    const elements = subtree.querySelectorAll('*');
    elements.forEach((element, index) => {
      if (!element.id) {
        element.id = `${ prefix }-${ index }`;
      }
    });
  }

  render(): TemplateResult {
    if (!this._templateCache) {
      Array.from(this.childNodes).forEach((child) => this.innerDOM.appendChild(child));
      //todo recheck if the uniqueIds are really needed for correct morphdom updates
      //this.assignUniqueIds(this.innerDOM, this.id ? this.id : this.generateUniqueKey());
      this.appendChild(this.innerDOM);

      const templateContent = this.innerHTML;
      this._templateCache = Handlebars.compile(templateContent);
    }

    const rendered = this._templateCache(this.data, {
      data: {
        emptyContext: !this.data || Object.keys(this.data).length === 0,
      },
    });

    morphdom(this.innerDOM, rendered);

    return html``;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cv-template': TemplateComponent;
  }
}
